// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-select-wraper .react-dropdown .react-dropdown-btn {
    padding: 5px;
    padding-left: 25px;
    padding-right: 22px;
    width: 293px;
    height: 75px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    border-radius: 10px;
    background: #fff;
    border: 2px solid #00A19B;
}



.filter-select-wraper .select-box-wrapper {
    margin-top: 0px;
}

.filter-select-wraper .selected-item {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 18px;
    font-weight: 500;
    position: relative;
}


.filter-select-wraper .react-dropdown-btn .selected-item p {
    margin: 0px;
    font-size: 20px;
    color: #606060;
    font-weight: 400;
}


.filter-select-wraper .react-dropdown .dropdown-content {
    margin: 0 auto;
    background: #F8F8F8;
    width: 300px;
    cursor: pointer;
    z-index: 9;
    padding-bottom: 12px;
    border-radius: 10px;
    background: #F8F8F8;
    position: absolute;
    top: 80;
    left: 0;
    opacity: 1;
    transform: translateY(3px);
    animation: slideIn 0.4s forwards;
    max-height: 50vh;
    overflow: auto;
}


.filter-select-wraper .dropdown-item.active {
    background: #00A19B !important;
    border-radius: 8px;
    margin-top: 10px;
}


.dropdown-item:focus, .dropdown-item:hover {
    color: #1e2125;
    background-color: #00A19B !important;
    border-radius: 8px;
}


.filter-select-wraper .select-box-wrapper {
    position: relative;
}


.filter-select-wraper .react-dropdown .dropdown-content .dropdown-item {
    padding: 10px;
    padding-left: 25px;
    padding-right: 25px;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    gap: 12px;
    font-weight: 500;
    width: 278px;
    height: 50px;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
}

.filter-select-wraper .dropdown-options {
    display: flex;
    align-items: center;
    gap: 10px;
}


.filter-select-wraper .dropdown-selct-tick {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #FF9913;
    display: flex;
    align-items: center;
    justify-content: center;
}

.filter-select-wraper .react-dropdown label {
    font-size: 22px;
    color: #383838;
    font-weight: 500;
    margin-bottom: 8px;
    margin-left: 25px;
}

.filter-select-wraper .dropdown-options p {
    font-size: 18px;
    color: #717171;
    font-family: 'Montserrat';
    margin: 0px;
}


.filter-select-wraper .dropdown-item.active .dropdown-options p{
    color: #fff !important;
}

.filter-select-wraper .dropdown-item:hover .dropdown-options p{
    color: #fff;
}

.filter-select-wraper .rotate-arrow{
   transform: rotate(180deg) !important; 
}

.filter-select-wraper .dropdown-options img {
    width: 28px;
}

.filter-select-wraper .selected-item img {
    width: 32px;
}

.filter-select-wraper .filter-type-heading p {
    font-size: 20px;
    color: #383838;
    font-family: 'Montserrat';
    font-weight: 500;
    margin-bottom: 0px; 
}

.filter-select-wraper .filter-type-heading{
    padding-top: 20px;
    margin: 0px 30px;  
}


.filter-select-wraper .filter-type-heading.divided-border-line {
    border-top: 1px dashed #ccc;
}

.filter-select-wraper img.dropdown-down-arrow {
    width: 18px;
}


.filter-select-wraper .select-box-wrapper label {
    font-size: 22px;
    color: #1A1919;
    font-weight: 500;
    padding-left: 12px;
    margin: 0px;
    padding-bottom: 6px;
}



.application-status-change-dropdown .react-dropdown .react-dropdown-btn {
    width: 250px;
    height: 70px;
    border: 2px solid #00A19B;
}

.application-status-change-dropdown{
    margin-top: -80px;
}

.application-status-change-dropdown .select-box-wrapper label {
    font-size: 26px;
    color: #1A1919;
    font-weight: 500;
}

.application-status-change-dropdown .react-dropdown-btn .selected-item p {
    font-size: 18px;
}

.application-status-change-dropdown .react-dropdown .dropdown-content .dropdown-item {
    width: 92%;
}



@media(min-width: 1025px) and (max-width: 1199px){
 .filter-select-wraper {
        gap: 20px !important;
    }

    

    .filter-select-wraper .react-dropdown .react-dropdown-btn {
        width: 290px;
        height: 60px;
    }

    .filter-select-wraper .react-dropdown .dropdown-content {
        width: 290px;
    }

    .filter-select-wraper .react-dropdown .dropdown-content .dropdown-item {
        width: 265px;
        height: 65px;
    }


    .filter-select-wraper .head-status-filter-dropdown  .react-dropdown .react-dropdown-btn {
        width: 200px;
        height: 60px;
    }

    .filter-select-wraper .head-status-filter-dropdown .react-dropdown .dropdown-content {
        width: 200px;
    }

    .filter-select-wraper .head-status-filter-dropdown .react-dropdown .dropdown-content .dropdown-item {
        width: 180px;
        height: 52px;
    }

    .filter-select-wraper .selected-item p {
        width: 130px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .filter-select-wraper .head-status-filter-dropdown .dropdown-options p {
        font-size: 16px;
        width: 110px;
        text-align: left;
    }

    .filter-select-wraper .react-dropdown-btn .selected-item p {
        margin: 0px;
        font-size: 18px;
    }
    
    .filter-select-wraper .react-dropdown label {
        font-size: 18px;
        margin-left: 12px;
    }

    .filter-select-wraper .select-box-wrapper label {
        font-size: 16px;
    }

    .filter-select-wraper .selected-item img {
        width: 28px;
    }

    .filter-select-wraper .mobile-filter-drawer-wrap {
        gap: 30px
    }


    .filter-select-wraper img.dropdown-down-arrow {
        width: 14px;
    }

    .filter-select-wraper .dropdown-options p {
        font-size: 16px;
        width: 180px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    div#filtercanvasRight {
        width: 460px;
    }

}


@media(min-width: 1200px) and (max-width: 1599px){
    /* .react-dropdown .react-dropdown-btn {
        width: 260px;
        height: 70px;
    }

    .react-dropdown .dropdown-content {
        width: 260px;
    }


    .react-dropdown .dropdown-content .dropdown-item {
        width: 235px;
        height: 65px;
    }

    .selected-item p {
        width: 155px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .react-dropdown-btn .selected-item p {
        margin: 0px;
        font-size: 18px;
    }
    
    .react-dropdown label {
        font-size: 20px;
        margin-left: 20px;
    }

    .selected-item img {
        width: 28px;
    }

    .dropdown-options p {
        font-size: 16px;
    } */


    .filter-select-wraper {
        gap: 10px !important;
    }

    .filter-select-wraper img.dropdown-down-arrow {
        width: 14px;
    }

    .filter-select-wraper .react-dropdown .react-dropdown-btn {
        width: 220px;
        height: 60px;
    }

    .filter-select-wraper .react-dropdown .dropdown-content {
        width: 230px;
    }

    .filter-select-wraper .react-dropdown .dropdown-content .dropdown-item {
        width: 206px;
        height: 50px;
    }

    .filter-select-wraper .selected-item p {
        width: 130px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .filter-select-wraper .react-dropdown-btn .selected-item p {
        margin: 0px;
        font-size: 18px;
    }
    
    .filter-select-wraper .react-dropdown label {
        font-size: 18px;
        margin-left: 10px;
    }

    .filter-select-wraper .select-box-wrapper label {
        font-size: 18px;
    }

    .filter-select-wraper .selected-item img {
        width: 28px;
    }

    .filter-select-wraper .dropdown-options p {
        font-size: 16px;
        width: 130px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .filter-select-wraper .payment-table-status-wrapper .dropdown-options p{
        font-size: 16px;
        width: 60px;
    }

}




/*********** bank Payment status Change dropdown ****/
.payment-table-status-wrapper .react-dropdown .react-dropdown-btn {
    width: 167px;
    height: 50px;
    background: #00A19B;
}

.payment-table-status-wrapper .selected-item img {
    width: 18px;
    height: 18px;
}

.payment-table-status-wrapper .dropdown-options img {
    width: 18px;
    height: 18px;
}

.payment-table-status-wrapper .react-dropdown-btn .selected-item p {
    width: 80px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
    font-size: 16px;
    color: #717171;
}

.payment-table-status-wrapper img.dropdown-down-arrow {
    width: 12px;
    height: 10px;
}

.payment-table-status-wrapper .react-dropdown .dropdown-content .dropdown-item{
    width: 146px;
    height: 45px;
    margin-bottom: 10px; 
}

.payment-table-status-wrapper .react-dropdown .dropdown-content{
    width: 167px; 
}

.payment-table-status-wrapper .dropdown-options p{
    font-size: 16px;
}


.payment-table-status-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
}

.payment-table-status-wrapper select#status {
    width: 167px;
    height: 50px;
    border-radius: 8px;
    border: none;
    background: #00A19B;
    padding: 0px 10px;
    color: #717171;
    font-size: 18px;
    font-family: 'Montserrat';
    outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/Dashboard/Dropdown/Dropdown.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;;;AAIA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;;AAGA;IACI,WAAW;IACX,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;;AAGA;IACI,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,OAAO;IACP,UAAU;IACV,0BAA0B;IAC1B,gCAAgC;IAChC,gBAAgB;IAChB,cAAc;AAClB;;;AAGA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;AACpB;;;AAGA;IACI,cAAc;IACd,oCAAoC;IACpC,kBAAkB;AACtB;;;AAGA;IACI,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,WAAW;AACf;;;AAGA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;GACG,oCAAoC;AACvC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;;AAGA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;;;AAIA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;;;AAIA;CACC;QACO,oBAAoB;IACxB;;;;IAIA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;;IAGA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,uBAAuB;QACvB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI;IACJ;;;IAGA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;AAEJ;;;AAGA;IACI;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;OAsCG;;;IAGH;QACI,oBAAoB;IACxB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,uBAAuB;QACvB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;AAEJ;;;;;AAKA,qDAAqD;AACrD;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,aAAa;AACjB","sourcesContent":[".filter-select-wraper .react-dropdown .react-dropdown-btn {\n    padding: 5px;\n    padding-left: 25px;\n    padding-right: 22px;\n    width: 293px;\n    height: 75px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    border-radius: 10px;\n    background: #fff;\n    border: 2px solid #00A19B;\n}\n\n\n\n.filter-select-wraper .select-box-wrapper {\n    margin-top: 0px;\n}\n\n.filter-select-wraper .selected-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 18px;\n    font-weight: 500;\n    position: relative;\n}\n\n\n.filter-select-wraper .react-dropdown-btn .selected-item p {\n    margin: 0px;\n    font-size: 20px;\n    color: #606060;\n    font-weight: 400;\n}\n\n\n.filter-select-wraper .react-dropdown .dropdown-content {\n    margin: 0 auto;\n    background: #F8F8F8;\n    width: 300px;\n    cursor: pointer;\n    z-index: 9;\n    padding-bottom: 12px;\n    border-radius: 10px;\n    background: #F8F8F8;\n    position: absolute;\n    top: 80;\n    left: 0;\n    opacity: 1;\n    transform: translateY(3px);\n    animation: slideIn 0.4s forwards;\n    max-height: 50vh;\n    overflow: auto;\n}\n\n\n.filter-select-wraper .dropdown-item.active {\n    background: #00A19B !important;\n    border-radius: 8px;\n    margin-top: 10px;\n}\n\n\n.dropdown-item:focus, .dropdown-item:hover {\n    color: #1e2125;\n    background-color: #00A19B !important;\n    border-radius: 8px;\n}\n\n\n.filter-select-wraper .select-box-wrapper {\n    position: relative;\n}\n\n\n.filter-select-wraper .react-dropdown .dropdown-content .dropdown-item {\n    padding: 10px;\n    padding-left: 25px;\n    padding-right: 25px;\n    cursor: pointer;\n    transition: all 0.2s;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 18px;\n    gap: 12px;\n    font-weight: 500;\n    width: 278px;\n    height: 50px;\n    margin-left: 10px;\n    margin-right: 10px;\n    margin-bottom: 10px;\n}\n\n.filter-select-wraper .dropdown-options {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n\n.filter-select-wraper .dropdown-selct-tick {\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    background: #FF9913;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.filter-select-wraper .react-dropdown label {\n    font-size: 22px;\n    color: #383838;\n    font-weight: 500;\n    margin-bottom: 8px;\n    margin-left: 25px;\n}\n\n.filter-select-wraper .dropdown-options p {\n    font-size: 18px;\n    color: #717171;\n    font-family: 'Montserrat';\n    margin: 0px;\n}\n\n\n.filter-select-wraper .dropdown-item.active .dropdown-options p{\n    color: #fff !important;\n}\n\n.filter-select-wraper .dropdown-item:hover .dropdown-options p{\n    color: #fff;\n}\n\n.filter-select-wraper .rotate-arrow{\n   transform: rotate(180deg) !important; \n}\n\n.filter-select-wraper .dropdown-options img {\n    width: 28px;\n}\n\n.filter-select-wraper .selected-item img {\n    width: 32px;\n}\n\n.filter-select-wraper .filter-type-heading p {\n    font-size: 20px;\n    color: #383838;\n    font-family: 'Montserrat';\n    font-weight: 500;\n    margin-bottom: 0px; \n}\n\n.filter-select-wraper .filter-type-heading{\n    padding-top: 20px;\n    margin: 0px 30px;  \n}\n\n\n.filter-select-wraper .filter-type-heading.divided-border-line {\n    border-top: 1px dashed #ccc;\n}\n\n.filter-select-wraper img.dropdown-down-arrow {\n    width: 18px;\n}\n\n\n.filter-select-wraper .select-box-wrapper label {\n    font-size: 22px;\n    color: #1A1919;\n    font-weight: 500;\n    padding-left: 12px;\n    margin: 0px;\n    padding-bottom: 6px;\n}\n\n\n\n.application-status-change-dropdown .react-dropdown .react-dropdown-btn {\n    width: 250px;\n    height: 70px;\n    border: 2px solid #00A19B;\n}\n\n.application-status-change-dropdown{\n    margin-top: -80px;\n}\n\n.application-status-change-dropdown .select-box-wrapper label {\n    font-size: 26px;\n    color: #1A1919;\n    font-weight: 500;\n}\n\n.application-status-change-dropdown .react-dropdown-btn .selected-item p {\n    font-size: 18px;\n}\n\n.application-status-change-dropdown .react-dropdown .dropdown-content .dropdown-item {\n    width: 92%;\n}\n\n\n\n@media(min-width: 1025px) and (max-width: 1199px){\n .filter-select-wraper {\n        gap: 20px !important;\n    }\n\n    \n\n    .filter-select-wraper .react-dropdown .react-dropdown-btn {\n        width: 290px;\n        height: 60px;\n    }\n\n    .filter-select-wraper .react-dropdown .dropdown-content {\n        width: 290px;\n    }\n\n    .filter-select-wraper .react-dropdown .dropdown-content .dropdown-item {\n        width: 265px;\n        height: 65px;\n    }\n\n\n    .filter-select-wraper .head-status-filter-dropdown  .react-dropdown .react-dropdown-btn {\n        width: 200px;\n        height: 60px;\n    }\n\n    .filter-select-wraper .head-status-filter-dropdown .react-dropdown .dropdown-content {\n        width: 200px;\n    }\n\n    .filter-select-wraper .head-status-filter-dropdown .react-dropdown .dropdown-content .dropdown-item {\n        width: 180px;\n        height: 52px;\n    }\n\n    .filter-select-wraper .selected-item p {\n        width: 130px;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n    }\n\n    .filter-select-wraper .head-status-filter-dropdown .dropdown-options p {\n        font-size: 16px;\n        width: 110px;\n        text-align: left;\n    }\n\n    .filter-select-wraper .react-dropdown-btn .selected-item p {\n        margin: 0px;\n        font-size: 18px;\n    }\n    \n    .filter-select-wraper .react-dropdown label {\n        font-size: 18px;\n        margin-left: 12px;\n    }\n\n    .filter-select-wraper .select-box-wrapper label {\n        font-size: 16px;\n    }\n\n    .filter-select-wraper .selected-item img {\n        width: 28px;\n    }\n\n    .filter-select-wraper .mobile-filter-drawer-wrap {\n        gap: 30px\n    }\n\n\n    .filter-select-wraper img.dropdown-down-arrow {\n        width: 14px;\n    }\n\n    .filter-select-wraper .dropdown-options p {\n        font-size: 16px;\n        width: 180px;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        overflow: hidden;\n    }\n\n    div#filtercanvasRight {\n        width: 460px;\n    }\n\n}\n\n\n@media(min-width: 1200px) and (max-width: 1599px){\n    /* .react-dropdown .react-dropdown-btn {\n        width: 260px;\n        height: 70px;\n    }\n\n    .react-dropdown .dropdown-content {\n        width: 260px;\n    }\n\n\n    .react-dropdown .dropdown-content .dropdown-item {\n        width: 235px;\n        height: 65px;\n    }\n\n    .selected-item p {\n        width: 155px;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n    }\n\n    .react-dropdown-btn .selected-item p {\n        margin: 0px;\n        font-size: 18px;\n    }\n    \n    .react-dropdown label {\n        font-size: 20px;\n        margin-left: 20px;\n    }\n\n    .selected-item img {\n        width: 28px;\n    }\n\n    .dropdown-options p {\n        font-size: 16px;\n    } */\n\n\n    .filter-select-wraper {\n        gap: 10px !important;\n    }\n\n    .filter-select-wraper img.dropdown-down-arrow {\n        width: 14px;\n    }\n\n    .filter-select-wraper .react-dropdown .react-dropdown-btn {\n        width: 220px;\n        height: 60px;\n    }\n\n    .filter-select-wraper .react-dropdown .dropdown-content {\n        width: 230px;\n    }\n\n    .filter-select-wraper .react-dropdown .dropdown-content .dropdown-item {\n        width: 206px;\n        height: 50px;\n    }\n\n    .filter-select-wraper .selected-item p {\n        width: 130px;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n    }\n\n    .filter-select-wraper .react-dropdown-btn .selected-item p {\n        margin: 0px;\n        font-size: 18px;\n    }\n    \n    .filter-select-wraper .react-dropdown label {\n        font-size: 18px;\n        margin-left: 10px;\n    }\n\n    .filter-select-wraper .select-box-wrapper label {\n        font-size: 18px;\n    }\n\n    .filter-select-wraper .selected-item img {\n        width: 28px;\n    }\n\n    .filter-select-wraper .dropdown-options p {\n        font-size: 16px;\n        width: 130px;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        overflow: hidden;\n    }\n\n    .filter-select-wraper .payment-table-status-wrapper .dropdown-options p{\n        font-size: 16px;\n        width: 60px;\n    }\n\n}\n\n\n\n\n/*********** bank Payment status Change dropdown ****/\n.payment-table-status-wrapper .react-dropdown .react-dropdown-btn {\n    width: 167px;\n    height: 50px;\n    background: #00A19B;\n}\n\n.payment-table-status-wrapper .selected-item img {\n    width: 18px;\n    height: 18px;\n}\n\n.payment-table-status-wrapper .dropdown-options img {\n    width: 18px;\n    height: 18px;\n}\n\n.payment-table-status-wrapper .react-dropdown-btn .selected-item p {\n    width: 80px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    text-align: left;\n    font-size: 16px;\n    color: #717171;\n}\n\n.payment-table-status-wrapper img.dropdown-down-arrow {\n    width: 12px;\n    height: 10px;\n}\n\n.payment-table-status-wrapper .react-dropdown .dropdown-content .dropdown-item{\n    width: 146px;\n    height: 45px;\n    margin-bottom: 10px; \n}\n\n.payment-table-status-wrapper .react-dropdown .dropdown-content{\n    width: 167px; \n}\n\n.payment-table-status-wrapper .dropdown-options p{\n    font-size: 16px;\n}\n\n\n.payment-table-status-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.payment-table-status-wrapper select#status {\n    width: 167px;\n    height: 50px;\n    border-radius: 8px;\n    border: none;\n    background: #00A19B;\n    padding: 0px 10px;\n    color: #717171;\n    font-size: 18px;\n    font-family: 'Montserrat';\n    outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
